import { render, staticRenderFns } from "./PerspectiveDefinitionForm.vue?vue&type=template&id=6bdf7871"
import script from "./PerspectiveDefinitionForm.vue?vue&type=script&lang=js"
export * from "./PerspectiveDefinitionForm.vue?vue&type=script&lang=js"
import style0 from "./PerspectiveDefinitionForm.vue?vue&type=style&index=0&id=6bdf7871&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports